import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MainContainer from "../../container/MainContainer";
import UserTable from "./Table";
import Arrow from "../../images/Arrow-Right.svg";
import GreenCheck from "../../images/green-check.svg";
import GrayCheck from "../../images/gray-check.svg";
import { useLazyQuery, useQuery } from "@apollo/react-hooks";
import { LIST_TICKET } from "../../query/listTickets";
import { hasuraClient } from "../../apolloClient";
import moment from "moment";
import { GET_EVENT_BY_ID } from "../../query/GetEventById";

const EventDetailsTable = (props) => {
  const { id } = props.match.params;

  const [pageCount, setPageCount] = React.useState(0);
  const [data, setData] = useState([]);

  const [
    listTicket,
    { data: listData, loading: listDataLoading, error: listDataError },
  ] = useLazyQuery(LIST_TICKET, {
    client: hasuraClient,
  });

  const { data: eventData } = useQuery(GET_EVENT_BY_ID, {
    client: hasuraClient,
    fetchPolicy: "cache-and-network",
    variables: {
      id: id,
      userId: localStorage.getItem("user_id"),
      current_date_time: moment().format(),
    },
  });

  useEffect(() => {
    listTicket({
      variables: {
        id: id,
        search: "%%",
      },
    });
  }, []);

  useEffect(() => {
    if (listData && listData?.events_list_view?.length) {
      setData(listData?.events_list_view);
      setPageCount(listData?.events_list_view_aggregate?.aggregate?.count);
    } else {
      setData([]);
      setPageCount(0);
    }
  }, [listData]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Ticket No.",
        accessor: (current_details) => {
          return <div>#{current_details?.ticket_number}</div>;
        },
      },
      {
        Header: "Customer",
        accessor: (current_details) => {
          return <div>{current_details?.customer}</div>;
        },
      },
      {
        Header: "Purchased",
        accessor: (current_details) => {
          return (
            <div>{moment(current_details?.purchase).format("DD.MM.YY")}</div>
          );
        },
      },
      {
        Header: "Total",
        accessor: (current_details) => {
          return <div>{current_details?.total}</div>;
        },
      },
      {
        Header: "Payment",
        accessor: (current_details) => {
          return <div>{current_details?.payment}</div>;
        },
      },
      {
        Header: "Type",
        accessor: (current_details) => {
          return <div>{current_details?.type}</div>;
        },
      },
      {
        Header: "REDEEM",
        accessor: (current_details) => {
          return (
            <div>
              {current_details?.redeem ? (
                <img src={GreenCheck} />
              ) : (
                <img src={GrayCheck} />
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <MainContainer active="events">
      <section className="post-block">
        <div className="main-title">
          <div className="back-button">
            <Link to={`/event-details/${id}`}>
              <img src={Arrow} alt="arrow right" />
            </Link>
            <h2>{eventData?.events_by_pk?.name}</h2>
          </div>
        </div>
        <UserTable
          columns={columns}
          setPageCount={setPageCount}
          pageCount={pageCount}
          data={data}
          listTicket={listTicket}
          id={id}
          loading={listDataLoading}
          error={listDataError}
        />
      </section>
    </MainContainer>
  );
};

export default EventDetailsTable;
